<script setup>
// Rede só de publicação (X, Threads, Pinterest…): o card de Novo canal abre
// esta tela; conectou, volta para a lista de Canais, onde a conta aparece.
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import SocialConnect from '../components/SocialConnect.vue';

defineProps({
  platform: { type: String, required: true },
});

const router = useRouter();
const { t } = useI18n();

const onConnected = () => {
  useAlert(t('INBOX_MGMT.ADD.SOCIAL_NETWORK.CONNECTED'));
  router.push({ name: 'settings_inbox_list' });
};
</script>

<template>
  <div class="h-full p-6 w-full max-w-full flex-shrink-0 flex-grow-0">
    <SocialConnect :platform="platform" @connected="onConnected" />
  </div>
</template>
